import { SecurityIcon } from './SecurityIcon';

/**
 * author: Google
 * id 0C2F3617-9710-4265-AFB5-29C52AD2FBE0
 * name security
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/security.svg
 * tags
 */
export const AdministratorIcon = SecurityIcon;
export default AdministratorIcon